import { render, staticRenderFns } from "./HappyAtSea.vue?vue&type=template&id=895f153c"
import script from "./HappyAtSea.vue?vue&type=script&lang=js"
export * from "./HappyAtSea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports